import * as React from 'react';
import { APIError } from '../../api';
import { ErrorName } from '../../enums/ErrorName';
import { AlertType } from '../../types/AlertType';
import { Alert } from 'rcd-cpp-ui/ui/alert/Alert';
import { ValidationResponse } from '../../types/ValidationResponse';

export class FieldValidationError extends APIError<ValidationResponse> {
  constructor(
    message: string,
    info: ValidationResponse,
    type: AlertType = 'error'
  ) {
    super(message, info, type, ErrorName.FieldValidationError);
  }
}

type Props = { error: FieldValidationError; onClose: () => void };

export const FieldValidationAlert = ({ error, onClose }: Props) => {
  const errors = error?.additionalInfo?.errors;
  if (!errors?.length) return null;

  return (
    <Alert type={error.type as any} onClose={onClose}>
      {errors.map((v, index) => (
        <div key={index}>{v.validationMessage}</div>
      ))}
    </Alert>
  );
};
